import React, { useState } from "react";
import "./Price.css"; // CSSファイルをインポート
import { useLanguage } from "./LanguageProvider"; // LanguageProviderからuseLanguageをインポート

const Price = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupImageSrc, setPopupImageSrc] = useState("");
  const { translate } = useLanguage(); // useLanguageフックでtranslateを取得

  const handleImageClick = (src) => {
    if (isPopupOpen && popupImageSrc === src) {
      // 同じ画像をもう一度タップした場合 → 閉じる
      setIsPopupOpen(false);
      setPopupImageSrc("");
    } else {
      // 画像を開く
      setPopupImageSrc(src);
      setIsPopupOpen(true);
    }
  };

  const handleOverlayClick = () => {
    setIsPopupOpen(false);
  };

  return (
    <div id="price">
      <div className="price-plan">
        <div className="plan" id="loopAnimation">
          <div className="plan-name">{translate("loopAnimation.title")}</div>
          <p className="price">{translate("loopAnimation.basePrice")}</p>
          <ul>
            {translate("loopAnimation.items").map((item, index) => (
              <li key={index}>
                {item.name}
                <br />
                {item.price}
                {item.note && <small>{item.note}</small>}
              </li>
            ))}
          </ul>
          <div className="options">
            <ul>
              {translate("loopAnimation.options") &&
                translate("loopAnimation.options").map((option, index) => (
                  <li key={index}>
                    {option.name}：{option.list01}
                    <br />
                    {option.list02}
                  </li>
                ))}
            </ul>
          </div>
          <div className="sample-popup" id="loopPopup">
            <img
              src="price/korone.gif"
              alt={translate("loopAnimation.sample")}
              onClick={() => handleImageClick("price/korone.gif")}
            />
            <img
              src="price/flying_Mumei.gif"
              alt={translate("loopAnimation.sample")}
              onClick={() => handleImageClick("price/flying_Mumei.gif")}
            />
          </div>
        </div>

        <div className="plan" id="illustration">
          <div className="plan-name">
            {translate("illustration.title")}
            <br />
            {translate("illustration.size")}
          </div>
          <p className="price">{translate("illustration.basePrice")}</p>
          <ul>
            {translate("illustration.items").map((item, index) => (
              <li key={index}>
                {item.name}：
                <br />
                {item.price}
              </li>
            ))}
          </ul>
          <div className="options">
            <ul>
              {translate("illustration.options").map((option, index) => (
                <li key={index}>
                  {option.name}：{option.price}
                </li>
              ))}
            </ul>
          </div>
          <div className="sample-popup" id="illustrationPopup">
            <img
              src="price/SUBAAA.png"
              alt={translate("illustration.sample")}
              onClick={() => handleImageClick("price/SUBAAA.png")}
            />
            <img
              src="price/pirate_Fauna.png"
              alt={translate("illustration.sample")}
              onClick={() => handleImageClick("price/pirate_Fauna.png")}
            />
            <img
              src="price/doob.png"
              alt={translate("illustration.sample")}
              onClick={() => handleImageClick("price/doob.png")}
            />
          </div>
        </div>

        <div className="plan" id="emoteAnimation">
          <div className="plan-name">
            {translate("emoteAnimation.title")}
            <br />
            {translate("emoteAnimation.size")}
          </div>
          <p className="price">{translate("emoteAnimation.price1")}</p>
          <ul>
            <li>{translate("emoteAnimation.set3")}</li>
            <li>{translate("emoteAnimation.set6")}</li>
            <li>{translate("emoteAnimation.moreThan7")}</li>
          </ul>
          <div className="sample-popup" id="emotePopup">
            <img
              src="price/emote_laugh.gif"
              alt={translate("emoteAnimation.sample")}
              onClick={() => handleImageClick("price/emote_laugh.gif")}
            />
          </div>
        </div>

        <div className="plan" id="emoteIllustration">
          <div className="plan-name">
            {translate("emoteIllustration.title")}
            <br />
            {translate("emoteIllustration.size")}
          </div>
          <p className="price">{translate("emoteIllustration.price1")}</p>
          <ul>
            <li>{translate("emoteIllustration.set3")}</li>
            <li>{translate("emoteIllustration.set6")}</li>
            <li>{translate("emoteIllustration.moreThan7")}</li>
          </ul>
          <div className="sample-popup" id="emoteIllustrationPopup">
            <img
              src="price/emote_img.png"
              alt={translate("emoteIllustration.sample")}
              onClick={() => handleImageClick("price/emote_img.png")}
            />
          </div>
        </div>

        <div className="plan" id="3d">
          <div className="plan-name">{translate("3d.title")}</div>
          <p className="price">{translate("3d.price")}</p>
          <ul>
            <li>{translate("3d.set1")}</li>
            <li>{translate("3d.set2")}</li>
            <li>{translate("3d.set3")}</li>
          </ul>
        </div>
      </div>

      <div className="price-ps">
        {translate("additionalNotes").map((note, index) => (
          <p key={index}>{note}</p>
        ))}
      </div>

      {/* ポップアップ表示 */}
      {isPopupOpen && (
        <div className="popup-overlay" onClick={handleOverlayClick}>
          <img src={popupImageSrc} alt="Popup Image" />
        </div>
      )}
    </div>
  );
};

export default Price;
